import { render, staticRenderFns } from "./_AdmissionNumberDialog.vue?vue&type=template&id=6364407a"
import script from "./_AdmissionNumberDialog.vue?vue&type=script&lang=js"
export * from "./_AdmissionNumberDialog.vue?vue&type=script&lang=js"
import style0 from "./_AdmissionNumberDialog.vue?vue&type=style&index=0&id=6364407a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports